import s from './Cover.module.sass'

import { FC, ReactNode, useContext } from 'react'

import { ImgContext, ObjectIdContext } from '@shared/ui/Layout/Cover/Cover'
import { MediaImg } from '@shared/ui/Media/MediaImg'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  children: ReactNode
  className?: string
  alt?: string
}

const CoverAside: FC<Props> = ({ children, className = '', alt = 'image cover' }) => {
  const { isMobile, designEnv } = useClientResponsive()
  const imgSrc = useContext(ImgContext)
  const objectId = useContext(ObjectIdContext)
  const isMobileLayout = designEnv === 'default' || isMobile

  const imgSizes = {
    width: isMobileLayout ? 400 : 900,
    height: isMobileLayout ? 245 : 500,
  }

  return (
    <aside className={s['aside-wrapper']} data-visible='true'>
      <div className={s['aside-container']}>
        <div className={`${s.aside} ${className}`}>
          <div className={s['aside-inner']}>
            <MediaImg
              placeholder={null}
              image={{
                url: imgSrc,
                width: imgSizes.width,
                height: imgSizes.height,
                description: alt,
              }}
              objectId={objectId}
              flexible={true}
              className={s.img}
            />
          </div>
          {children}
        </div>
      </div>
    </aside>
  )
}

export default CoverAside
